import { render, staticRenderFns } from "./BusDataSyncDocMainSetList.vue?vue&type=template&id=156c10a1&scoped=true&"
import script from "./BusDataSyncDocMainSetList.vue?vue&type=script&lang=js&"
export * from "./BusDataSyncDocMainSetList.vue?vue&type=script&lang=js&"
import style0 from "./BusDataSyncDocMainSetList.vue?vue&type=style&index=0&id=156c10a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c10a1",
  null
  
)

export default component.exports